/** OpenZeppelin documentation (see OpenZeppelin/docs PRs #142 and #145). */
export const DOCS_UIKIT = 'https://docs.openzeppelin.com/tools/uikit';
export const DOCS_ECOSYSTEM_ADAPTERS = 'https://docs.openzeppelin.com/tools/ecosystem-adapters';
